export default [
    {
        policyCode: 'POLICY-CODE-0001',
        policyName: 'National Defense Authorization Act for Fiscal Year 2025',
        policyWebsiteUrl: 'https://www.congress.gov/bill/118th-congress/house-bill/5009',
        policyInfoContent: `
            <div class="header-size header-bold-text w-100 text-center">Short Summary</div>

            <div class="header-size header-italized-text w-100 text-center">Authorization of FY 2025 appropriations for the Department of Defense</div>

            <div class="header-size header-bold-text w-100 text-center">National Defense Authorization Act for Fiscal Year 2025</div>

            <div class="text-content text-start my-3">
                On December 23, 2024, H.R. 5009, the Servicemember Quality of Life Improvement and
                National Defense Authorization Act for Fiscal Year 2025 (NDAA 2025), was signed into law.
                The NDAA authorizes $895.2 billion in funding for distribution amongst the United States
                military, intelligence, and defense spheres for the upcoming fiscal year. The bill contains a list of
                cybersecurity measures, focused on strengthening both foreign and domestic cyber defense.
            </div>

            <div class="w-100 text-start text-content my-1">Key provisions include:</div>

            <div class="w-100 my-3">
                <ul>
                    <li class="text-content">
                        $3 billion to fund the Federal Communication Commission’s “rip-and-replace" program,
                        an initiative put forth to remove networking equipment manufactured by Chinese
                        telecommunications companies from United States communications infrastructure.
                        Although the program was initially launched in 2020, urgency to replenish funding for
                        the program had risen in the wake of recent hacking campaigns on U.S.
                        telecommunications networks launched by the Chinese government.
                    </li>

                    <li class="text-content">
                        An amendment allowing Department of Defense components to independently purchase
                        cybersecurity products, if there is a perceived compelling need to do so. This modifies a
                        provision in the 2022 NDAA, which streamlined procurement of cybersecurity products
                        and services through a centralized program management office. The amendment came
                        amid concern of overconfidence on the current “one-size-fits-all” approach to DoD
                        components, and the overreliance on products supplied by major technology companies.
                        Under this provision, DoD components will be better able to tailor their cybersecurity
                        approach to what best fits their needs and requirements.
                    </li>

                    <li class="text-content">
                        Requirement for the Department of Defense Chief Information Officer to establish
                        guidelines for application of the current DoD zero-trust strategy to the Internet of Things
                        (IoT) hardware used in military operations. While military IoT hardware (i.e. wearable
                        devices, sensors, etc.) is beneficial in data collection and distribution, it also creates a
                        vulnerable attack surface for our adversaries. Integration of zero-trust principles into this
                        technology would better safeguard against cyber-attacks and reinforce the military’s
                        security architecture.
                    </li>

                    <li class="text-content">
                        Establishment of a threat tabletop exercise program to aid the Department of Defense and
                        the defense industrial base in preparation for cyber-attacks during or prior to times of
                        conflict or war.
                    </li>
                </ul>
            </div>

            <div class="w-100 my-3 text-start text-content">
                In addition to military and defense spending, the bill also sets aside funding for science and
                technology initiatives. This includes authorization for $143.8 billion in research, development,
                testing and evaluation to address emergent force protection concerns, and $17.5 billion for
                science and technology programs, in addition to direct financial assistance from defense
                laboratories for educational partnerships.
            </div>

            <div class="header-size header-bold-text w-100 text-start">
                How does this affect you?
            </div>

            <div class="w-100 my-3 text-start text-content">
                Organizations contracting with the Department of Defense or operating within the defense
                industrial base may benefit from the act’s provisions through allocated funding for operational
                advancement, technological innovation, and new initiatives. It may also be possible to receive
                funding as an organization for research and development of new technology pertaining to
                national defense, as well as for educational partnerships to foster the connection between
                educational institutions and industry.
            </div>
        `,
    },
    {
        policyCode: 'POLICY-CODE-0002',
        policyName: 'NIST SP 800-171',
        policyWebsiteUrl: 'https://nvlpubs.nist.gov/nistpubs/SpecialPublications/NIST.SP.800-171r3.pdf',
        policyInfoContent: `
            <div class="header-size header-bold-text w-100 text-center">Short Summary</div>

            <div class="header-size header-italized-text w-100 text-center">Recommended requirements for safeguarding CUI outside of federal systems and organizations</div>

            <div class="header-size header-bold-text w-100 text-center">NIST SP 800-171</div>

            <p class="text-content text-start my-3">
                &nbsp;&nbsp;&nbsp;&nbsp;NIST Special Publication 800-171 is a set of guidelines published by the National
                Institute of Standards and Technology (NIST) aimed at maintaining the confidentiality of
                controlled unclassified information (CUI) in non-federal information systems and organizations.
                It provides a standardized approach to protecting sensitive information that non-federal entities,
                such as government contractors, may handle as a part of a contract with the government. The
                requirements outlined in NIST SP 800-171 apply to any non-federal components that may store,
                process, or transmit CUI, in addition to those which may provide protection for any such
                components. They are intended for use in government contracts, or any other established
                agreements between federal agencies and any non-federal organization.
            </p>

            <p class="text-content text-start my-3">
                &nbsp;&nbsp;&nbsp;&nbsp;NIST SP 800-171 organizes the requirements for protecting CUI into control families,
                which address different aspects of system security. Organizations must address each requirement
                in their submitted system security plan (SSP), detailing how each requirement is met, or how
                currently unmet requirements will be met in the future. The SSP is then submitted to the
                responsible contracting office or federal agency for review prior to continuing forward with a
                contract or agreement.
            </p>

            <div class="header-size header-bold-text w-100 text-start">
                How does this affect you?
            </div>

            <div class="w-100 my-3 text-start text-content">
                &nbsp;&nbsp;&nbsp;&nbsp;Organizations that store, process, or transmit CUI are required to fully comply with NIST
                SP 800-171. Failure to comply with these standards may result in a loss of, or inability to obtain
                federal contracts and may increase an organization’s risk of a cyber incident.
            </div
        `,
    },
    {
        policyCode: 'POLICY-CODE-0003',
        policyName: 'NIST SP 800-53',
        policyWebsiteUrl: 'https://nvlpubs.nist.gov/nistpubs/SpecialPublications/NIST.SP.800-53r5.pdf',
        policyInfoContent: `
            <div class="header-size header-bold-text w-100 text-center">Short Summary</div>

            <div class="header-size header-italized-text w-100 text-center">Catalog of security and privacy controls for protecting systems & information</div>

            <div class="header-size header-bold-text w-100 text-center">NIST SP 800-53</div>

            <p class="text-content text-start my-3">
                &nbsp;&nbsp;&nbsp;&nbsp;In today’s cybersecurity landscape, there is an urgent need for the protection of critical
                infrastructure and the underlying components and structures that support national security
                interests. NIST SP 800-53 offers a comprehensive framework for safeguarding the systems and
                information that comprise our infrastructure. Developed by the National Institute of Standards
                and Technology (NIST), the publication details a systematic approach to improve organizational
                security standards by promoting system resilience and survivability, mitigating privacy risks, and
                ensuring operational continuity.
            </p>

            <p class="text-content text-start my-3">
                &nbsp;&nbsp;&nbsp;&nbsp;NIST SP 800-53 provides a comprehensive catalog of security and privacy controls that
                address a wide range of security challenges including data protection, access management, and
                threat detection. These controls encompass both technical and non-technical measures and
                specify whether implementation is the responsibility of the organization or the system. In
                addition to functional implementation, the framework includes assurance-focused controls to
                verify the reliability and effectiveness of implemented security mechanisms. While compliance
                is mandatory for federal information systems, the flexibility of the NIST SP 800-53 framework
                allows for adoption by other organizations as well.
            </p>

            <div class="header-size header-bold-text w-100 text-start">
                How does this affect you?
            </div>

            <div class="w-100 my-3 text-start text-content">
                &nbsp;&nbsp;&nbsp;&nbsp;The importance of this framework lies in its role in developing an adaptable, trustworthy
                security architecture. NIST SP 800-53 is both flexible and scalable, allowing for organizations to
                tailor adoption to their specific environment and needs. This helps to ensure that an
                organization’s security architecture remains effective in addressing emerging threats in an ever-
                evolving cybersecurity landscape.
            </div>
        `,
    },
    {
        policyCode: 'POLICY-CODE-0004',
        policyName: 'Cybersecurity Maturity Model Certification',
        policyWebsiteUrl: 'https://dodcio.defense.gov/CMMC/About/',
        policyInfoContent: `
            <div class="header-size header-bold-text w-100 text-center">Short Summary</div>

            <div class="header-size header-italized-text w-100 text-center mt-3 mb-3">The Cybersecurity Maturity Model Certification framework is designed to enforce the protection of shared sensitive information</div>

            <div class="header-size header-bold-text w-100 text-center">Cybersecurity Maturity Model Certification</div>

            <p class="text-content text-start my-3">
                &nbsp;&nbsp;&nbsp;&nbsp;The Cybersecurity Maturity Model Certification (CMMC) program is an assessment
                framework developed by the Department of Defense (DoD). It was designed to enforce the
                protection of sensitive information including Controlled Unclassified Information (CUI) and
                Federal Contract Information (FCI). Requiring contractors and subcontractors to adhere to a
                specified level of security compliance, the DoD can better safeguard sensitive information and
                strengthen the cybersecurity of the Defense Industrial Base (DIB).
            </p>

            <p class="text-content text-start my-3">
                &nbsp;&nbsp;&nbsp;&nbsp;The current CMMC program is a tiered model, meaning that the level of cybersecurity
                that organizations must meet is dependent on both the type and sensitivity of the information
                being handled. There are three levels of CMMC compliance that organizations may be required
                to meet, ranging from basic cyber hygiene to expert practices, depending on the nature of their
                contract. The assessment process allows the DoD to verify correct implementation of the
                required cybersecurity standards.
            </p>

            <div class="header-size header-bold-text w-100 text-start">
                How does this affect you?
            </div>

            <div class="w-100 my-3 text-start text-content">
                &nbsp;&nbsp;&nbsp;&nbsp;Organizations seeking to contract with the Department of Defense must be CMMC
                compliant. Compliance ensures the protection of shared sensitive information and demonstrates a
                commitment to upholding the principles of our national security. If an organization is non-
                compliant, the result may be a loss of current DoD contracts, or the inability to obtain new
                contracts.
            </div>
        `,
    },
    {
        policyCode: 'POLICY-CODE-0005',
        policyName: 'Modernizing Defense Acquisitions and Spurring Innovation in the Defense Industrial Base',
        policyWebsiteUrl: 'https://www.federalregister.gov/documents/2025/04/15/2025-06461/modernizing-defense-acquisitions-and-spurring-innovation-in-the-defense-industrial-base',
        policyInfoContent: `
            <div class="header-size header-bold-text w-100 text-center">Short Summary</div>

            <div class="header-size header-italized-text w-100 text-center mt-3 mb-3">Executive order mandating reform of the defense acquisition system.</div>

            <div class="header-size header-bold-text w-100 text-center">Modernizing Defense Acquisitions and Spurring Innovation in the Defense Industrial Base</div>

            <div class="text-content text-start my-3">
                &nbsp;&nbsp;On April 9th, 2025, the President of the United States issued Executive Order 14265, 
                Modernizing Defense Acquisitions and Spurring Innovation in the Defense Industrial Base. The 
                order directs the Department of Defense (DoD) to reform its existing acquisition process, 
                constituting a “comprehensive overhaul” of the systems currently in place. The order is part of 
                the Administration’s efforts to bolster government efficiency and comes alongside a number of 
                other Executive Orders aimed at the same overarching goal. To facilitate this, the order mandates 
                the following:
            </div>

            <div class="w-100 my-3">
                <ul>
                    <li class="text-content">
                        The Secretary of Defense must, within 60 days of the order (by June 8th, 2025) submit a 
                        plan to reform the DoD acquisition process. This plan must include a first preference for 
                        utilization of commercial solutions, accompanied with a general preference for “Other 
                        Transactions Authority, application of Rapid Capabilities Office policies, or any other 
                        authorities or pathways to promote streamlined acquisitions under the Adaptative 
                        Acquisition Framework.”
                    </li>

                    <li class="text-content">
                        Review of all functional support roles within the acquisition workforce for the purpose of 
                        removing roles that perform unnecessary or redundant tasks and streamlining the 
                        decision-making process by removing duplicate approval requirements. Additionally, 
                        within 120 days of the order (August 7th, 2025), the Secretary of Defense must submit a 
                        plan to “reform, right-size, and train the acquisition workforce”.
                    </li>

                    <li class="text-content">
                        Removal or revision of any unnecessary supplemental regulations present in the Defense 
                        Federal Acquisition Regulation Supplement (DFARS) and Financial Management 
                        Regulation (FMR) to expedite the acquisition process. In similar function, a review of the 
                        Joint Capabilities Integration and Development System must be conducted within 180 
                        days of issuance of the order (October 6th, 2025) to remove unnecessary processes that 
                        may serve as a hindrance to an efficient and effective acquisition process. 
                    </li>

                    <li class="text-content">
                        Comprehensive review of all Major Defense Acquisition Programs (MDAPs), within 90 days 
                        (July 8th, 2025), coupled with a subsequent review of all major systems. MDAPs 
                        that are 15% behind schedule based on the current Acquisition Program Baseline (APB), 
                        15 % over cost, unable to meet key performance parameters, or are otherwise unaligned 
                        with existing mission priorities, will be considered for potential cancellation. 
                    </li>
                </ul>
            </div>

            <div class="header-size header-bold-text w-100 text-start">
                How does this affect you?
            </div>

            <div class="w-100 my-3 text-start text-content">
                &nbsp;&nbsp;For federal contractors, EO 14275 may reduce oversight of contractor performance, thus 
                heightening the need for additional certification and internal policing by the contractor to ensure 
                adequate contract fulfillment. Because EO 14275 may affect contract evaluation and awarding 
                decisions, contractors should also be prepared for potential dispute or pushback on existing or 
                developing contract parameters. Contractors should also be prepared to formulate proposals that 
                underscore efficiency and innovation, in adherence to the desired attributes of processes and 
                programs put forth by the order. For MDAP contractors, strict tracking of performance and 
                cost to ensure alignment with the 15% limit is advisable to reduce the threat of program cancellation. 
                Accommodation requests should be submitted in advance of review to ensure adequate 
                adherence to budget and performance requirements.
            </div>
        `,
    },
    {
        policyCode: 'POLICY-CODE-0006',
        policyName: 'Restoring Common Sense to Federal Procurement',
        policyWebsiteUrl: 'https://www.federalregister.gov/documents/2025/04/18/2025-06839/restoring-common-sense-to-federal-procurement',
        policyInfoContent: `
            <div class="header-size header-bold-text w-100 text-center">Short Summary</div>

            <div class="header-size header-italized-text w-100 text-center mt-3 mb-3">Executive order mandating wholistic revisions to the Federal Acquisition Regulation (FAR).</div>

            <div class="header-size header-bold-text w-100 text-center">Restoring Common Sense to Federal Procurement</div>

            <div class="text-content text-start my-3">
                &nbsp;&nbsp;On April 15th, 2025, the President of the United States issued Executive Order 14275, 
                <i>Restoring Common Sense to Federal Procurement.</i> The order calls for revision of the Federal 
                Acquisition Regulation (FAR), which is an extensive set of rules and procedures jointly issued 
                by the Department of Defense (DoD), General Services Administration (GSA) and National 
                Aeronautics and Space Administration (NASA) to govern the acquisition of services and supplies 
                by the federal government. As the current administration has deemed the existing FAR as 
                inefficient, Executive Order 14275 aims to streamline and strengthen the procurement process 
                through the FAR by mandating a comprehensive reform to the existing documentation. Key 
                provisions include: 
            </div>

            <div class="w-100 my-3">
                <ul>
                    <li class="text-content">
                        Removal of all provisions not required by law or otherwise deemed necessary to support 
                        simplicity and usability in federal procurement, or to protect economic and national 
                        security interests, and;
                    </li>

                    <li class="text-content">
                        Consideration of the incorporation of a “sunset” clause mandating expiration of any 
                        retained provisions not required by statute after four years, unless renewed by the FAR 
                        council.
                    </li>
                </ul>
            </div>

            <div class="w-100 text-content text-start my-3">
                &nbsp;&nbsp;This effort has been referred to as the “Revolutionary FAR Overhaul (RFO)” and is expected 
                to be completed within 180 days of the order’s issuance. It will be carried out by the Office of 
                Federal Procurement Policy (OFPP) within the Office of Management and Budget (OMB) in 
                collaboration with the FAR council. The order also dictates that all agencies with additional 
                procurement regulations communicate with OFPP and the FAR council to ensure alignment with 
                the incoming changes. 
            </div>

            <div class="header-size header-bold-text w-100 text-start">
                How does this affect you?
            </div>

            <div class="w-100 my-3 text-start text-content">
                &nbsp;&nbsp;For federal contractors, Executive Order 14275 may result in fewer compliance hurdles 
                when dealing with acquisition of commercial products and services. The reduction of regulatory 
                requirements may reduce barriers to entry for commercial contractors, small businesses, and 
                other new entrants. During this shift, contractors may be expected to adhere to interim guidance 
                standards put forth by their contracting agency and should prepare accordingly. 
            </div>
        `,
    },
    {
        policyCode: 'POLICY-CODE-0007',
        policyName: 'Ensuring Commercial, Cost-Effective Solutions in Federal Contracts',
        policyWebsiteUrl: 'https://www.federalregister.gov/documents/2025/04/18/2025-06835/ensuring-commercial-cost-effective-solutions-in-federal-contracts',
        policyInfoContent: `
            <div class="header-size header-bold-text w-100 text-center">Short Summary</div>

            <div class="header-size header-italized-text w-100 text-center mt-3 mb-3">Executive order aimed at streamlining federal procurement processes by prioritizing the use of existing commercial solutions over custom or commercially unavailable solutions.</div>

            <div class="header-size header-bold-text w-100 text-center">Ensuring Commercial, Cost-Effective Solutions in Federal Contracts</div>

            <div class="w-100 text-content text-start my-3">
                On April 16th, 2025, the President of the United States issued Executive Order 14271, <i>Ensuring 
                Commercial, Cost-Effective Solutions in Federal Contracts.</i> The current administration claims 
                that previous administrations’ overreliance on procuring custom products and services has led to 
                the overspending on and hindering of integrating commercially available solutions in 
                government procurement. To reduce waste and increase the efficiency of government 
                procurement processes, Executive Order 14271 requires the use of commercially available 
                products and services across all agencies, to the maximum extent of which it is possible. Within 
                60 days of issuance (June 15th, 2025), each government agency’s contracting officer must 
                identify, “all open agency solicitations, pre-solicitation notices, solicitation notices, award 
                notices, and sole source notices for non-commercial products or services.” The contracting 
                officer must subsequently apply for each pursued non-commercial item to proceed with its 
                solicitation, including the rationale for pursuance and supporting research and price analysis. 
                Within 30 days of application submission, the agency’s approving authority will then assess each 
                proposal’s compliance with the guidelines put forth by the Federal Acquisition Streamlining Act 
                (FASA) and provide a decision on each proposal. Additionally, within 120 days of order issuance 
                (August 7th, 2025), approving authorities must provide a report to the Director of the Office of 
                Management and Budget (OMB) demonstrating the agency’s compliance with FAFA and 
                progress made toward implementation of EO 14271. 
            </div>

            <div class="header-size header-bold-text w-100 text-start">
                How does this affect you?
            </div>

            <div class="w-100 my-3 text-start text-content">
                Executive Order 14271 may pose a risk to smaller government contractors, as a larger pivot 
                toward acquisition of industry solutions could lead to less opportunities being available for small 
                business participation. The Department of Defense may seek partnerships with entities that are 
                privately funded rather than those reliant on government spending; disproportionately affecting 
                small businesses which may not have the resources to carry out requested operations when 
                compared to larger businesses. Federal contractors that already offer commercially available 
                solutions may be favored in contract awarding, which has potential market implications for 
                government products and services.
            </div>
        `,
    },
];